import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ProjectStateService } from "@project/project-state.service";

@Component({
  selector: "app-project",
  template: ` <router-outlet></router-outlet>`,
  providers: [ProjectStateService],
  imports: [RouterModule],
  standalone: true,
})
export class ProjectComponent {
  constructor() {
    inject(ProjectStateService);
  }
}
